/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/views/Auth'
import FirstInfo from '@/views/FirstInfo'
import Home from '@/views/Home'
import RequireDetails from '@/views/Associate/RequireDetails'
import AssociateDashboard from '@/views/Associate/AssociateDashboard'
import EmployeeDashboard from '@/views/Employee/EmployeeDashboard'
import AdminDashboard from '@/views/Admin/AdminDashboard'
import AssociatesView from '@/views/Admin/AssociatesView'
import AdminSchoolsView from '@/views/Admin/Schools/SchoolsView'
import AddSchool from '@/views/Admin/Schools/AddSchool'
import EditSchool from '@/views/Admin/Schools/EditSchool'
import AddProgram from '@/views/Admin/Programs/AddProgram'
import EditProgram from '@/views/Admin/Programs/EditProgram'
import AdminProgramsView from '@/views/Admin/Programs/ProgramsView'
import AddEmployee from '@/views/Admin/Employees/AddEmployee'
import EditEmployee from '@/views/Admin/Employees/EditEmployee'
import EmpResetPassword from '@/views/Admin/Employees/EmpResetPassword'
import EmployeesView from '@/views/Admin/Employees/EmployeesView'
import ViewApplications from '@/views/Admin/Applications/ViewApplications'
import BulkUpload from '@/views/Admin/BulkUpload'

import AppSchoolsView from '@/views/Common/AppSchoolsView'
import AppSchoolView from '@/views/Common/AppSchoolView'
import AppProgramsView from '@/views/Common/AppProgramsView'
import StudentDashboard from '@/views/Student/StudentDashboard'
import StudentDashboardContent from '@/views/Student/StudentDashboardContent'
import StudentApplications from '@/views/Student/StudentApplications'

import AddStudentProfile from '@/views/Student/Profile/AddStudentProfile'
import EmployeeDashboardContent from '@/views/Employee/EmployeeDashboardContent'
import EmployeeApplications from '@/views/Employee/EmployeeApplications'
import EmployeeApplicationsView from '@/views/Employee/Applications/EmployeeApplicationsView'
import EmployeeNotifications from '@/views/Employee/EmployeeNotifications'

import EmployeeSchoolsView from '@/views/Employee/EmployeeSchoolsView'
import EmployeeSchoolView from '@/views/Employee/EmployeeSchoolView'
import EmployeeProgramsView from '@/views/Employee/EmployeeProgramsView'
import EmployeeAddStudent from '@/views/Employee/EmployeeAddStudent'
import EmployeeEditStudent from '@/views/Employee/EmployeeEditStudent'
import EmployeeViewStudents from '@/views/Employee/EmployeeViewStudents'

import AdminSchoolsWebView from '@/views/Admin/AdminSchoolsWebView'
import AdminSchoolWebView from '@/views/Admin/AdminSchoolWebView'
import AdminApplications from '@/views/Admin/AdminApplications'

import AssociateDashboardContent from '@/views/Associate/AssociateDashboardContent'
import AssociateAddStudent from '@/views/Associate/AssociateAddStudent'
import AssociateEditStudent from '@/views/Associate/AssociateEditStudent'
import AssociateViewStudents from '@/views/Associate/AssociateViewStudents'
import AssociateSchoolsView from '@/views/Associate/AssociateSchoolsView'
import AssociateSchoolView from '@/views/Associate/AssociateSchoolView'
import AssociateProgramsView from '@/views/Associate/AssociateProgramsView'
import AssociateApplications from '@/views/Associate/AssociateApplications'

Vue.use(Router)

var routes = [
  // { path: '/home', name: 'Home', component: Home },
  { path: '/auth', name: 'Auth', component: Auth },
  // { path: '/first-info', name: 'FirstInfo', component: FirstInfo, meta: { requireAuth: true } },
  { 
    path: '/associate',
    name: 'AssociateDashboard',
    component: AssociateDashboard,
    meta: { requireAuth: true },
    children: [
      { path: 'dashboard', name: 'AssociateDashboardContent', component: AssociateDashboardContent, meta: {requireAuth: true} },
      { path: 'schools', name: 'AssociateSchoolsView', component: AppSchoolsView, meta: {requireAuth: true} },
      { path: 'school/:id', name: 'AssociateSchoolView', component: AssociateSchoolView, meta: {requireAuth: true} },
      { path: 'programs', name: 'AssociateProgramsView', component: AssociateProgramsView, meta: {requireAuth: true} },
      { path: 'add-student-profile', name: 'AssociateAddStudent', component: AssociateAddStudent, meta: {requireAuth: true} },
      { path: 'edit-student-profile/:id', name: 'AssociateEditStudent', component: AssociateEditStudent, meta: {requireAuth: true} },
      { path: 'students', name: 'AssociateViewStudents', component: AssociateViewStudents, meta: {requireAuth: true} },
      { path: 'applications', name: 'AssociateApplications', component: AssociateApplications, meta: {requireAuth: true} }
    ]
  },
  { path: '/associate/require-details', name: 'RequireDetails', component: RequireDetails, meta: { requireAuth: true } },
  {
    path: '/employee',
    name: 'EmployeeDashboard',
    component: EmployeeDashboard,
    meta: { requireAuth: true },
    children: [
      { path: 'dashboard', name: 'EmployeeDashboardContent', component: EmployeeDashboardContent, meta: {requireAuth: true} },
      { path: 'schools', name: 'EmployeeSchoolsView', component: AppSchoolsView, meta: {requireAuth: true} },
      { path: 'school/:id', name: 'EmployeeSchoolView', component: EmployeeSchoolView, meta: {requireAuth: true} },
      { path: 'programs', name: 'EmployeeProgramsView', component: EmployeeProgramsView, meta: {requireAuth: true} },
      { path: 'applications', name: 'EmployeeApplications', component: EmployeeApplications, meta: {requireAuth: true} },
      { path: 'notifications', name: 'EmployeeNotifications', component: EmployeeNotifications, meta: {requireAuth: true} },
      { path: 'add-student-profile', name: 'EmployeeAddStudent', component: EmployeeAddStudent, meta: {requireAuth: true} },
      { path: 'edit-student-profile/:id', name: 'EmployeeEditStudent', component: EmployeeEditStudent, meta: {requireAuth: true} },
      { path: 'students', name: 'EmployeeViewStudents', component: EmployeeViewStudents, meta: {requireAuth: true} },
    ]
  },
  {
    path: '/student',
    name: 'StudentDashboard',
    component: StudentDashboard,
    meta: { requireAuth: true },
    children: [
      { path: '', name: 'AddStudentProfile', component: AddStudentProfile, meta: {requireAuth: true} },
      { path: 'dashboard', name: 'StudentDashboardContent', component: AddStudentProfile, meta: {requireAuth: true} },
      { path: 'schools', name: 'StudentSchoolsView', component: AppSchoolsView, meta: {requireAuth: true} },
      { path: 'school/:id', name: 'StudentSchoolView', component: AppSchoolView, meta: {requireAuth: true} },
      { path: 'programs', name: 'StudentProgramsView', component: AppProgramsView, meta: {requireAuth: true} },
      { path: 'profile', name: 'AddStudentProfile', component: AddStudentProfile, meta: {requireAuth: true} },
      { path: 'applications', name: 'StudentApplications', component: StudentApplications, meta: {requireAuth: true} }
    ]
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requireAuth: true },
    children: [
      { path: 'associates', name: 'AssociatesView', component: AssociatesView, meta: {requireAuth: true} },
      { path: 'schools', name: 'AdminSchoolsView', component: AdminSchoolsView, meta: {requireAuth: true} },
      { path: 'add-school', name: 'AddSchool', component: AddSchool, meta: {requireAuth: true} },
      { path: 'edit-school/:schoolId', name: 'EditSchool', component: EditSchool, meta: {requireAuth: true} },
      { path: 'edit-program/:programId', name: 'EditProgram', component: EditProgram, meta: {requireAuth: true} },
      { path: 'webapp-schools', name: 'AdminSchoolsWebView', component: AdminSchoolsWebView, meta: {requireAuth: true} },
      { path: 'webapp-schools/:id', name: 'AdminSchoolWebView', component: EmployeeSchoolView, meta: {requireAuth: true} },
      { path: 'add-program', name: 'AddProgram', component: AddProgram, meta: {requireAuth: true} },
      { path: 'programs', name: 'AdminProgramsView', component: AdminProgramsView, meta: {requireAuth: true} },
      { path: 'webapp-programs', name: 'AdminProgramsWebView', component: EmployeeProgramsView, meta: {requireAuth: true} },
      { path: 'add-employee', name: 'AddEmployee', component: AddEmployee, meta: {requireAuth: true} },
      { path: 'edit-employee/:id', name: 'EditEmployee', component: EditEmployee, meta: {requireAuth: true} },
      { path: 'emp-reset-password/:id', name: 'EmpResetPassword', component: EmpResetPassword, meta: {requireAuth: true} },
      { path: 'employees', name: 'EmployeesView', component: EmployeesView, meta: {requireAuth: true} },
      { path: 'applications', name: 'AdminApplications', component: EmployeeApplications, meta: {requireAuth: true} },
      { path: 'bulk-upload', name: 'BulkUpload', component: BulkUpload, meta: {requireAuth: true} },
      { path: 'notifications', name: 'AdminNotifications', component: EmployeeNotifications, meta: {requireAuth: true} },
      { path: 'add-student-profile', name: 'AdminAddStudent', component: EmployeeAddStudent, meta: {requireAuth: true} },
      { path: 'edit-student-profile/:id', name: 'AdminEditStudent', component: EmployeeEditStudent, meta: {requireAuth: true} },
      { path: 'students', name: 'AdminViewStudents', component: EmployeeViewStudents, meta: {requireAuth: true} }
    ]
  },
  { path: '*', redirect: '/auth' }
]

const router = new Router({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js